import { MsgBoxService } from './../../../msg-boxes/msg-box.service';
// external imports
import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, AfterViewInit, ErrorHandler } from '@angular/core';
import { AppConfig } from '../../../app.config';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';

declare var jwplayer: any;

@Component({
  selector: 'app-jwplayer',
  templateUrl: './jwplayer.component.html',
  styleUrls: ['./jwplayer.component.scss']
})
export class JWPlayerComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  static elementId: number = 0;

  @Input('sensor') public sensor: SensorCoreObject;
  @Input() public analysedVid: boolean = false;

  public showOverlay = AppConfig.settings.alertAddress.enableOverlay;

  private _streamerElement!: ElementRef | null;
  numberOfRetries: number = 4;
  errorCounter: number = 0;
  @ViewChild('streamerElement', { static: false }) set streamerElement(elm: ElementRef | null) {
    this.disposeStreamer();
    if (elm) {
      this._streamerElement = elm;
      this.elementId && this.createStreamer();
    }
  }
  get streamerElement(): ElementRef | null {
    return this._streamerElement;
  }

  @ViewChild('playerWrapper') public streamWrapper: ElementRef;

  public jwPlayerInstance: any = null;
  public url: string;
  public elementId!: string;

  public videoWidth: number = 0;
  public videoHeight: number = 0;

  constructor(protected videoSvc: VideoMsgMngrService, private msgBoxSrv: MsgBoxService) { }

  ngOnInit(): void {
    this.elementId = "app-jwplayer-el-" + JWPlayerComponent.elementId.toString();
    JWPlayerComponent.elementId += 1;
    this.configureUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size'] && changes['size'].currentValue && this.jwPlayerInstance != null) {
      this.jwPlayerInstance.resize(this.videoWidth, this.videoHeight);
    }
    if (changes['analysedVid']) {
      this.disposeStreamer();
      this.configureUrl();
    }
    if (changes['sensor']) {
      this.errorCounter 
      this.disposeStreamer();
      this.configureUrl();
    }
  }

  ngAfterViewInit(): void {
    const el = this.streamWrapper.nativeElement
    this.startPollingSize(el);
  }

  startPollingSize(el: HTMLElement) {
    let lastWidth = el.clientWidth;
    let lastHeight = el.clientHeight;
    this.videoWidth = el.clientWidth;
    this.videoHeight = el.clientHeight;
    setInterval(() => {
      if (el.clientWidth !== lastWidth || el.clientHeight !== lastHeight) {
        lastWidth = el.clientWidth;
        lastHeight = el.clientHeight;
        this.videoWidth = el.clientWidth;
        this.videoHeight = el.clientHeight;
      }
    }, 500);
  }

  ngOnDestroy(): void {
    this.disposeStreamer();
  }

  configureUrl() {
    if (!AppConfig.settings.videoAddress.useTokenOnStream)
      this.url = this.sensor.videoLink;
    else {
      let camName = this.sensor.streamName;
      let streamPrefix = this.videoSvc.getStreamPrefixForCameraToken(this.sensor.videoLink,camName);
      if (this.analysedVid) 
        camName = camName.replace('.stream', 'A.stream');
      console.log("configureUrl");
      this.videoSvc.getCameraToken(camName, streamPrefix).subscribe(
        (Data) => {
          this.url = this.sensor.videoLink + Data;
          if (this.analysedVid) 
            this.url = this.url.replace('.stream', 'A.stream');
          this.createStreamer();
        },
        (error) => {
          console.log("Cannot Get Video Token");
        }
      )
    }
  }

  private createStreamer(): void {
    if (this.url) {
      this.jwPlayerInstance = jwplayer(this.elementId).setup({
        file: this.url,
        aboutlink: '',
        controls: 'true',
        title: '',
        stretching: 'uniform',
        autostart: 'true',
        primary: 'flash',
        skin: 'vapor',
        androidhls: 'true',
      });

      this.jwPlayerInstance.on('ready', () => {
        console.log("player initialized!");
        this.errorCounter = 0;
      });

      this.jwPlayerInstance.on('error', (e: any) => {
        console.log(`[jwPlayer][sensor: ${this.sensor.streamName}][counter: ${this.errorCounter}] player error:`, e);
        this.errorHandler(e);
      });
      this.jwPlayerInstance.on('setupError', (e: any) => {
        this.errorCounter += 1;
        console.log(`[jwPlayer][sensor: ${this.sensor.streamName}][counter: ${this.errorCounter}] player setupError:`, e);
        this.errorHandler(e);
        
      });
      this.jwPlayerInstance.on('bufferError', (e: any) => {
        this.errorCounter += 1;
        console.log(`[jwPlayer][sensor: ${this.sensor.streamName}][counter: ${this.errorCounter}] player bufferError:`, e);
        this.errorHandler(e);
        
      });
    }
  }
  
  public reloadPlayer() {
    const delayTime = 3000;
    this.disposeStreamer()

    setTimeout(() => {
      this.createStreamer();
      console.log(`[jwPlayer][sensor: ${this.sensor.streamName}][counter: ${this.errorCounter}] reloading `);
    }, delayTime);
  }

  private errorHandler(error: any) {
    this.errorCounter += 1;
    console.warn(`JWPlayer Error [${this.errorCounter}/${this.numberOfRetries}]`);
    if (this.errorCounter <= this.numberOfRetries){
      this.reloadPlayer();
    }
    else{
      console.error(`Max retries reached. Stream ${this.sensor.streamName} is unavailable`);
      this.msgBoxSrv.showErrorMsg(`Stream Error, Try Re-Open Player`);

    }

  }

  private disposeStreamer(): void {
    if (this.jwPlayerInstance) {
      this.jwPlayerInstance.remove();
      this.jwPlayerInstance = null;
    }
  }
}